import React, { useState, useEffect } from "react";
import { setReminderOndemand } from "../../../services/medium";
import { toast } from "react-toastify";
import moment from "moment";
import { useSelector } from "react-redux";
import { use } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useDynamicTranslation } from "../../../i18n/dynamicContent";

export default function BookAppointmentPopUp({
  directAppMediumInfo,
  booKGroupEvent,
  isWorker=0
}) {
  const { t } = useTranslation("mediumPracticePopups");
  const { formatDate } = useDynamicTranslation();
  const [value, setValue] = useState("");
  const [error, setError] = useState(false);
  const { timezone_name } = useSelector((state) => state.user.user);
  //  const [isWorker, setIsWorker] = useState(false);
  useEffect(() => {
   console.log(directAppMediumInfo, "directAppMediumInfo");
  }, [directAppMediumInfo]);

  // Display only: "Thursday, October 22, 2026" -> "jeudi 22 octobre 2026" (English unchanged).
  const currentUserDate = (day) =>
    formatDate(day, { weekday: "long", month: "long", day: "numeric", year: "numeric" }, moment(day, 'YYYY-MM-DD').format("dddd, MMMM DD, YYYY"));
  const { medium_name = "", fullday = "", backupdate = '', title = "",time = "", ondemand_session_category_id,subtext = "" } = directAppMediumInfo
  const categoryLabel =
    ondemand_session_category_id == "96" ? t("bookAppointment.category.communitySupportGroups") :
    ondemand_session_category_id == "95" ? t("bookAppointment.category.speakerEvent") :
    title === "Group Coaching" ? t("bookAppointment.category.group") :
    ondemand_session_category_id == "94" ? t("bookAppointment.category.coachedPracticeCircle") :
    ondemand_session_category_id == "99" ? t("bookAppointment.category.platformDemonstrationPractice") :
    ondemand_session_category_id == "101" ? t("bookAppointment.category.professionalDemonstration") :
    t("bookAppointment.category.practiceCircles");

  return (
    <div>
      <div
        id="BookAppointmentPopUp"
        class="modal fade bd-example-modal-lg mt-5 preview-modal-availability"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
      // data-backdrop="static"
      >
        <div class="modal-dialog modal-lg modal-dialog-preview text-center">
          <div class="modal-content p-5 ">
            <div className="cross-icon-popup">
              <img
                onClick={() =>
                  window.loadModal2("#BookAppointmentPopUp", "hide")
                }
                src="localImages/crossicon.png"
              />
            </div>
            {ondemand_session_category_id == "101" && isWorker == 1 && (
            <p className="font-size-24 line-height-36px">
              <Trans
                i18nKey="bookAppointment.confirmServe"
                ns="mediumPracticePopups"
                values={{ category: categoryLabel, date: currentUserDate(backupdate), time }}
                components={{ b: <b className="text-underline" /> }}
              />
            </p>
            )}
            {ondemand_session_category_id == "101" && isWorker == 0 && (
            <p className="font-size-24 line-height-36px">
              <Trans
                i18nKey="bookAppointment.confirmSelect"
                ns="mediumPracticePopups"
                values={{ category: categoryLabel, date: currentUserDate(backupdate), time }}
                components={{ b: <b className="text-underline" /> }}
              />
            </p>
            )}
            {ondemand_session_category_id != "101" && (
            <p className="font-size-24 line-height-36px">
              {console.log(title, "title")}
              <Trans
                i18nKey={ondemand_session_category_id != "95" ? "bookAppointment.confirmBookWith" : "bookAppointment.confirmBook"}
                ns="mediumPracticePopups"
                values={{ category: categoryLabel, name: ondemand_session_category_id != "95" ? medium_name : subtext, date: currentUserDate(backupdate) }}
                components={{ b: <b className="text-underline" /> }}
              />
            </p>
            )}
                  {/* <div className="worker-checkbox-section"
            >
              <input
                type="checkbox"
                id="workerCheckbox"
                checked={isWorker}
                onChange={(e) => setIsWorker(e.target.checked)}
                style={{ marginRight: "8px" }}
              />
              <p htmlFor="workerCheckbox" className="font-size-24" style={{ margin: 0 }}>
                I wish to attend this session as a worker.
              </p>
            </div> */}
            <form className="mt-5" id="msform">
              <div className="mt-2 ml-4 mr-4 d-flex justify-content-center align-items-center choose-medium">
                <button
                  type="button"
                  onClick={() =>
                    window.loadModal2("#BookAppointmentPopUp", "hide")
                  }
                  className="previous action-button-previous float-right width-unset pl-4 pr-4 mr-5 color-d5a67b color-d5a67b-qw"
                >
                  {t("common.no")}
                </button>

                <button
                  type="button"
                  onClick={booKGroupEvent}
                  className={`next action-button float-left margin-unset`}
                >
                  {t("common.yes")}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
